import _ from 'lodash'
import core from '../../core'

const { helpers: { keepInLength, getLoginFromMail, getUserId } } = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const managementStrategy = [
  { id: 1, label: '121 Session Notes' },
  { id: 2, label: 'Absence Management Plan' },
  { id: 3, label: 'Behaviour Management Plan' },
  { id: 4, label: 'Centre YP Meeting Minutes' },
  { id: 5, label: 'Child in Care Review Minutes' },
  { id: 6, label: "Child in Care Review Young Person's Consultation Form" },
  { id: 7, label: 'Conversation of Note' },
  { id: 8, label: 'Crisis Management Plan' },
  { id: 9, label: 'DCYA Report' },
  { id: 10, label: 'EPIC Report' },
  { id: 11, label: 'Evidencing Report Pending' },
  { id: 12, label: 'HIQA Inspection Report' },
  { id: 13, label: 'Key Work Session Notes' },
  { id: 14, label: 'Life Space Interview' },
  { id: 15, label: 'Monitoring report' },
  { id: 16, label: 'Ombudsman Report' },
  { id: 17, label: 'Placement Plan Session Notes' },
  { id: 18, label: 'Placement Support Plan' },
  { id: 19, label: 'Risk Management Plan' },
  { id: 20, label: 'Routine Management Plan' },
  { id: 21, label: 'Safety Plan' },
  { id: 22, label: 'Significant Event Report' },
  { id: 23, label: 'Situation Management Plan' },
  { id: 24, label: 'Tusla Report' },
  { id: 25, label: "Young Person's Daily Journal" },
  { id: 26, label: 'Other' }
]

export const riskStatus = [
  { id: 1, label: 'Closed' },
  { id: 2, label: 'Open' },
  { id: 3, label: 'Open - Closed to Referrals' },
  { id: 4, label: 'Open - Due to Close' }
]

export const riskOptions = [
  [
    { id: 1, label: 'Abduction' },
    { id: 2, label: 'Abuse - Emotional' },
    { id: 3, label: 'Abuse - Physical' },
    { id: 4, label: 'Abuse - Sexual' },
    { id: 5, label: 'Abuse - Sexual Exploitation' },
    { id: 6, label: 'Alcohol Overdose' },
    { id: 7, label: 'Alcohol Related Incident' },
    { id: 8, label: 'Assault - General' },
    { id: 9, label: 'Assault - With Weapon' },
    { id: 10, label: 'Bullying - By Others' },
    { id: 11, label: 'Bullying - Of Others' },
    { id: 12, label: 'Centre Disruption - By Others' },
    { id: 13, label: 'Centre Disruption - By Self' },
    { id: 14, label: 'Drug Overdose' },
    { id: 15, label: 'Drug Related Incident' },
    { id: 16, label: 'High Risk Behaviour - Of Others' },
    { id: 17, label: 'High Risk Behaviour - Of Self' },
    { id: 18, label: 'Property Damage - Centre' },
    { id: 19, label: 'Property Damage - Others' },
    { id: 20, label: 'Property Damage - Own' },
    { id: 21, label: 'Self-Harm' },
    { id: 22, label: 'Solvent Overdose' },
    { id: 23, label: 'Solvent Related Incident' },
    { id: 24, label: 'Suicide' },
    { id: 25, label: 'Traffic Accident' },
    { id: 26, label: 'Other' }
  ]
]

export const riskNature = [
  { id: 1, label: 'Harm' },
  { id: 2, label: 'Harm / Placement Collapse' },
  { id: 3, label: 'Harm / Significant Harm' },
  { id: 4, label: 'Harm / Significant Harm / Placement Collapse' },
  { id: 5, label: 'Placement Collapse' },
  { id: 6, label: 'Significant Harm' },
  { id: 7, label: 'Significant Harm / Placement Collapse' }
]

export const valueTable = {
  managementStrategy,
  riskStatus,
  riskOptions,
  riskNature
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'risk.date',
      'risk.identifiedRisk',
      'risk.nature',
      'risk.management',
      'risk.status',
      'risk.validFrom'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'risk.date',
    title: 'Risk Identified Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Risk Identified '
  },
  {
    name: 'risk.identifiedRisk',
    title: 'Identified Risk',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(riskOptions, ['id', parseInt(row[`risk.identifiedRisk`], 10)])
        ? _.find(riskOptions, ['id', parseInt(row[`risk.identifiedRisk`], 10)])
            .label
        : row[`risk.identifiedRisk`],
    options: 'riskOptions',
    filterField: true,
    minSpace: 'Identified Risk '
  },
  {
    name: 'risk.riskNature',
    title: 'Naure of Risk Identifed',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(riskNature, ['id', parseInt(row[`risk.riskNature`], 10)])
        ? _.find(riskNature, ['id', parseInt(row[`risk.riskNature`], 10)]).label
        : row[`risk.riskNature`],
    options: 'riskNature',
    filterField: true,
    minSpace: 'Naure of Risk '
  },
  {
    name: 'risk.notes',
    title: 'Risk Notes',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Risk Notes '
  },
  {
    name: 'risk.management',
    title: 'Risk Management Strategy Action(s) in Place',
    formField: true,
    maxChars: 300,
    filterField: true,
    minSpace: 'Risk Management Strategy '
  },
  {
    name: 'risk.managementEvidence',
    title: 'Risk Management Strategy Action(s) Evidenced',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(managementStrategy, [
        'id',
        parseInt(row[`risk.managementEvidence`], 10)
      ])
        ? _.find(managementStrategy, [
            'id',
            parseInt(row[`risk.managementEvidence`], 10)
          ]).label
        : row[`risk.managementEvidence`],
    options: 'managementStrategy',
    multiple: true,
    filterField: true,
    minSpace: 'Risk Management Strategy '
  },
  {
    name: 'risk.status',
    title: 'Risk Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(riskStatus, ['id', parseInt(row[`risk.status`], 10)])
        ? _.find(riskStatus, ['id', parseInt(row[`risk.status`], 10)]).label
        : row[`risk.status`],
    options: 'riskStatus',
    filterField: true,
    minSpace: 'Risk Status '
  },
  {
    name: 'risk.validFrom',
    title: 'Risk Status Valid at Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Valid at Date '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'risk',
      historyName: 'riskHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'rsk',
      activeName: 'risk',
      historyName: 'riskHistory',
      label: 'Risks',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'risk.date',
            label: 'Risk Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'risk.identifiedRisk',
            label: 'Identified Risk',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.riskOptions
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'risk.riskNature',
            label: 'Naure of Risk Identifed',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.riskNature.filter(f => f.id > 0).map(o => {
              return { value: o.id, label: o.label }
            })
          }
        ],
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'risk.notes',
          label: 'Risk Notes',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'risk.management',
          label: 'Risk Management Strategy Action(s) in Place',
          normalize: v => {
            const val = keepInLength(v, 300)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        },

        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'risk.managementEvidence',
          label: 'Risk Management Strategy Action(s) Evidenced',
          multiple: true,
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.managementStrategy
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'risk.status',
          label: 'Risk Status',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.riskStatus.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.datepicker,
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'risk.validFrom',
          label: 'Risk Status Valid at Date',
          required: showAsterix,
          openToYearSelection: openToYearSelection,
          hideCalendarDate: hideCalendarDate,
          textFieldStyle: { width: '100%', ...styles.fieldText },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['risk']

export const errors = [1, 2]

export const defaultNew = {
  risk: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  riskHistory: []
}

// "risks": [
//   {
// "risk": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "riskNature": 1,
//   "notes": "aaa",
//   "management": 2,
//   "managementEvidence": 2,
//   "status": 1,
//   "validFrom": "2001-01-01T23:28:56.782Z"
// },
// "riskHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/risks.js